<div #modal class="add-edit-modal">
  <div class="main-container">
    <div class="loader-overlay" *ngIf="isAPIResponsePending">
      <div class="loader"></div>
    </div>
    <div class="btn-container">
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closePopup()"
      >
        <span aria-hidden="true"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="30"
            height="30"
            viewBox="0 0 50 50"
          >
            <path
              d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"
            ></path>
          </svg>
        </span>
      </button>
    </div>
    <div class="modal-header">
      <span class="modal-title">{{
        paymentMethodData.id ? "Edit Payment Info" : "New Payment Info"
      }}</span>
      <div class="toggle-links" *ngIf="!paymentMethodData.id">
        <a
          href="javascript:void(0)"
          *ngIf="selectedOption == 'Card'"
          (click)="changeAddMethod('Bank')"
          >Add New Bank</a
        >
        <a
          href="javascript:void(0)"
          *ngIf="selectedOption == 'Bank'"
          (click)="changeAddMethod('Card')"
          >Add New Card</a
        >
      </div>
    </div>
    <app-bank
      *ngIf="selectedOption == 'Bank'"
      [ban]="ban"
      [paymentMethodData]="paymentMethodData"
      [apiResponseError]="apiError"
      (addPaymentMethod)="addPaymentMethod($event)"
      (updatePaymentMethod)="updatePaymentMethod($event)"
      (closeModal)="closePopup()"
    ></app-bank>
    <app-card
      *ngIf="selectedOption == 'Card'"
      [ban]="ban"
      [paymentMethodData]="paymentMethodData"
      [apiResponseError]="apiError"
      (addPaymentMethod)="addPaymentMethod($event)"
      (updatePaymentMethod)="updatePaymentMethod($event)"
      (closeModal)="closePopup()"
    ></app-card>
  </div>
</div>
